export class LineChartFilters extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {filters, activeFilter, maxRangeTimestamp, hideDisabledFilters} = this.props;
        return (
            <div className="line-chart-widget__graph-menu">
                {filters.map((filter) => {
                    if (!hideDisabledFilters || filter.isEnabled) {
                        const now = Date.now();
                        // Use Europe/Amsterdam timezone to ensure consistent date calculations regardless of user's local timezone.
                        // This prevents off-by-one-day errors when calculating date ranges (e.g., "1 month ago", "year to date")
                        // across different timezones, ensuring all users see the same data for the same calendar periods.
                        const amsterdamDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
                        const filterDate = new Date(amsterdamDate);
                        let monthsToSubtract = 0;
                        
                        switch (filter.variant) {
                            case "oneMonth":
                                monthsToSubtract = 1;
                                break;
                            case "threeMonths":
                                monthsToSubtract = 3;
                                break;
                            case "sixMonths":
                                monthsToSubtract = 6;
                                break;
                            case "oneYear":
                                monthsToSubtract = 12;
                                break;
                            case "threeYears":
                                monthsToSubtract = 36;
                                break;
                            case "fiveYears":
                                monthsToSubtract = 60;
                                break;
                        }

                        if(filter.variant === "yearToDate") {
                            filterDate.setMonth(0);
                            filterDate.setDate(1);
                        } else {
                            filterDate.setMonth(filterDate.getMonth() - monthsToSubtract);
                        }
                        
                        const minimumRange = filterDate.getTime();
                        const maximumRange = maxRangeTimestamp ?? now;
                        let buttonClass = `button ${activeFilter !== filter.variant? 'button-white' : ''}`;
                        
                        return (
                            <button
                                key={filter.variant}
                                disabled={!filter.isEnabled}
                                data-minrange={minimumRange}
                                data-maxrange={maximumRange}
                                data-variant={filter.variant}
                                className={buttonClass}
                                type="button"
                            >
                                {filter.text}
                            </button>
                        );
                    }
                })}
            </div>
        );
    }
}
